import React from 'react';

import { ListItemLi } from '@r1-frontend/ui-react/organisms/Footer/components/LinkItem/ListItemLi';

import * as ST from './styled';

interface ILink {
    link: string,
    text: string,
}

interface IFooterLinks {
    title: string,
    links: ILink[],
}

export const FooterLinks = ({ title, links }: IFooterLinks) =>
    <ST.FooterLinks>
        <ST.LinksTitle>{title}</ST.LinksTitle>
        <ST.LinksList>
            {links.map((item) => <ListItemLi text={item.text} link={item.link} key={item.text}/>)}
        </ST.LinksList>
    </ST.FooterLinks>;
